import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { changePasswordApi, getCurrentUser } from "../apis/userApi";
import { loadNotifications, readAllNotificationApi, readNotificationApi } from "../apis/notificationApi";

export const useLoadNotification = (enabled, page = 0) => {
  return useQuery({
    queryKey: ["load_notification", page],
    queryFn: () => loadNotifications(page, 5),
    retry: false,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!enabled,
  });
};

export const useReadNotification = (options = {}) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["mark_as_read"],
    mutationFn: async (payload) => {
      return readNotificationApi(payload);
    },
    onSuccess() {
      qClient.invalidateQueries();
    },
  });
};

export const useReadAllNotification = (options = {}) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["mark-all_as_read"],
    mutationFn: async () => {
      return readAllNotificationApi();
    },
    onSuccess() {
      qClient.invalidateQueries();
    },
  });
};
